export default "__VITE_ASSET__aefe9e0b__"